import { GOOGLE_LOCATION_USE_API } from '../config'
import GoogleLocationAPI from './GoogleLocationAPI'
import { GoogleLocationClient } from './GoogleLocationAPI.model'
import { googleLocationStub } from './googleLocationStub'

/** The one switch between the backend and the stand-in (`config.ts`). */
export const googleLocationClient: GoogleLocationClient =
  GOOGLE_LOCATION_USE_API ? GoogleLocationAPI : googleLocationStub
